import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  @Input()
  public showLanguageChooser: boolean = true;
  @Input()
  public showYaraLogo: boolean = true;
  @Input()
  bannerImage: string;
  constructor() { }

  ngOnInit(): void {
  }

}
